/**
 * Mirrors Global.Core.Enums.Jobsites.SelectionsCopyBlockedReason
 */
export enum SelectionsCopyBlockedReason {
    None = 0,
    /**
     * Source and destination are on opposite selections experiences, which have no translation between them
     */
    ExperienceMismatch = 1,
    /**
     * Both sides on Selections Reimagined, but this pairing cannot copy options yet,
     * tracked separately, so the picker leaves it alone
     */
    SelectionOptionsUnsupported = 2,
}

/**
 * What a blocked copy is being made into
 */
export type SelectionsCopyDestination = "job" | "template";

export interface ISelectionsCopyBlockedMessageParams {
    blockedReason: SelectionsCopyBlockedReason;
    /**
     * Whether the source is on Selections Reimagined, which names the direction of the mismatch
     */
    isSourceSelectionsReimagined: boolean;
    destination: SelectionsCopyDestination;
}

/**
 * What to tell the builder about a blocked selections copy, or undefined when there is nothing to explain
 */
export const selectionsCopyBlockedMessage = ({
    blockedReason,
    isSourceSelectionsReimagined,
    destination,
}: ISelectionsCopyBlockedMessageParams): string | undefined => {
    // SelectionOptionsUnsupported is deliberately unexplained - that copy is meant to start working instead
    if (blockedReason !== SelectionsCopyBlockedReason.ExperienceMismatch) {
        return undefined;
    }

    return isSourceSelectionsReimagined
        ? `This template uses the new selections experience and cannot be copied to this ${destination} using the legacy experience.`
        : `This template uses the legacy selections experience and cannot be copied to this ${destination} using the new experience.`;
};

/**
 * What to tell the builder when the source template and the destination are on opposite selections
 * experiences, named from the template's side
 */
export const mixedSelectionsExperienceMessage = (isSourceSelectionsReimagined: boolean): string =>
    isSourceSelectionsReimagined
        ? "New selections and allowances cannot be copied into legacy selections."
        : "Legacy selections and allowances cannot be copied into new selections.";
